import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { PROBLEMS } from "@/data/content";

export const Problem = () => {
  return (
    <section id="soluciones" className="py-20 md:py-28 bg-[#2b2a33] text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-2xl">
          <span className="text-xs font-semibold tracking-[0.25em] uppercase text-[#ffc247]">
            Cómo te ayudamos
          </span>
          <h2 className="font-display text-4xl md:text-5xl font-extrabold tracking-tight mt-4 leading-tight">
            ¿Te suena familiar? Así resolvemos tus problemas.
          </h2>
          <p className="mt-5 text-lg text-white/60 leading-relaxed">
            Liderar un negocio, cuidar de tu familia y gestionar tu día a día puede ser desafiante.
            Estamos para simplificar, organizar y ayudarte a avanzar con claridad y tranquilidad.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {PROBLEMS.map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.07 }}
              data-testid={`problem-card-${i}`}
              className="flex flex-col bg-white/[0.04] border border-white/10 rounded-2xl p-7 hover:bg-white/[0.07] transition-colors"
            >
              <p className="font-display text-lg font-bold uppercase tracking-wide text-[#ff5c49]">
                {item.title}
              </p>
              <p className="mt-3 text-sm text-white/60 leading-relaxed flex-1">{item.desc}</p>
              <div className="flex items-start gap-3 mt-5 pt-5 border-t border-white/10">
                <ArrowRight className="w-5 h-5 text-[#ff5c49] shrink-0 mt-0.5" />
                <p className="text-sm text-white/85 leading-relaxed font-medium">{item.fix}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
